export default "<p>my-account-admin works!</p>\r\n"